export const Tools = {
  displayNames: {
    vsaasAccessControlReport: "Access Control Report",
    vsaasBulkStateChange: "Bulk State Change",
    vsaasCargoContainerLog: "Cargo Container Registry",
    vsaasCountReport: "VSaaS BI",
    vsaasEventImageReport: "Event Images Report",
    vsaasFaceDatabase: "Face Collections",
    vsaasFaceDetectionsSearch: "Face Detections Search",
    vsaasGranularity: "Granularity Dashboard",
    vsaasOpenGateReport: "Open Gate Report",
    vsaasOperabilitySummary: "Operative Assets Summary",
    vsaasRoundsReportV2: "Rounds Report (v2)",
    vsaasTelegramEvents: "Telegram Events",
    xompassAnnualReport: "Annual report",
    xompassBIPanels: "BI Panel",
    xompassCCTV: "CCTV",
    xompassDetectionHistory: "Detection History",
    xompassDetectionsHeatmap: "Detections Heatmap",
    xompassDeviceEventDashboard: "Edge Events Dashboard",
    xompassEdgeMonitoring: "Edge Devices Monitoring",
    xompassEmbeddedReports: "Embedded Reports",
    xompassEventDashboard: "Event Dashboard",
    xompassEventDashboardDemo: "Demo Event Dashboard",
    xompassEventDetectionReport: "Event Detections Report",
    xompassEventHistory: "Event History",
    xompassEventReport: "Event Report",
    xompassForensicAnalysis: "Forensic Analysis",
    xompassForensicLicensePlate: "License plates Search",
    xompassForensicLicensePlateBlacklist: "License Plates of interest",
    xompassForensicLicensePlateBlacklistDetections: "Detections of interest",
    xompassForensicReconstruction: "Forensic Reconstruction",
    xompassForensicRetail: "Retail - Forensic Search",
    xompassGIS: "Gis",
    xompassImportantEvents: "Important Events",
    xompassKeyValueData: "Historical Data",
    xompassLCEventReport: "Event Report Las Condes",
    xompassOvaDashboard: "OVA Monitoring",
    xompassPeopleCounterDailyReport: "Counter Daily Report",
    xompassPeopleCounterReports: "Count Report (legacy)",
    xompassPeopleCounterWeeklyReport: "Counter Weekly Report",
    xompassRealTime: "Real Time",
    xompassResponseProtocol: "Response Protocols",
    xompassRoundsReport: "Rounds Report (legacy)",
    xompassSCADA: "Process Layout",
    xompassStoreAnomaliesDashboard: "Anomalous sales management",
    xompassStoreAnomaliesReport: "Anomalous sales report",
    xompassStoreForensicSales: "Retail Sales",
    xompassStoreHeatmap: "Store Heatmap (beta)",
    xompassStoreOpeningReport: "Store Opening Report",
    xompassStoryline: "Storyline",
    xompassTimeSeries: "Time Series",
    xompassTrafficFlowAnalysis: "Traffic Flow Analysis",
    xompassVehicleInspectionReports: "Vehicle Inspection Report",
  },
};
